import React from 'react';
import { Card } from './ui/card';
import { Button } from './ui/button';
import { Check, Star } from 'lucide-react';
import { pricingPlans } from '../mock';

const Pricing = () => {
  return (
    <section id="pricing" className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-5xl md:text-6xl font-bold mb-4 bg-gradient-to-r from-cyan-600 to-teal-600 bg-clip-text text-transparent">
            Pricing
          </h2>
          <p className="text-xl text-slate-600 max-w-2xl mx-auto">
            Flexible packages to fit every occasion and budget
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 max-w-7xl mx-auto">
          {pricingPlans.map((plan) => (
            <Card
              key={plan.id}
              className={`relative overflow-hidden border-2 transition-all duration-500 ${
                plan.popular
                  ? 'border-cyan-500 shadow-2xl scale-105 bg-gradient-to-b from-white to-cyan-50/30'
                  : 'border-slate-200 shadow-lg hover:shadow-xl hover:border-cyan-300 bg-white'
              }`}
            >
              {/* Popular badge */}
              {plan.popular && (
                <div className="absolute top-0 right-0 bg-gradient-to-r from-cyan-500 to-teal-500 text-white px-4 py-1 text-sm font-semibold flex items-center gap-1">
                  <Star className="w-4 h-4 fill-current" />
                  Most Popular
                </div>
              )}

              <div className="p-8">
                {/* Plan name */}
                <h3 className="text-2xl font-bold text-slate-800 mb-2">{plan.name}</h3>
                <p className="text-slate-600 mb-6">{plan.duration}</p>

                {/* Price */}
                <div className="mb-8">
                  <div className="flex items-baseline gap-2">
                    <span className="text-5xl font-bold bg-gradient-to-r from-cyan-600 to-teal-600 bg-clip-text text-transparent">
                      ${plan.price}
                    </span>
                  </div>
                </div>

                {/* Features */}
                <div className="space-y-4 mb-8">
                  {plan.features.map((feature, index) => (
                    <div key={index} className="flex items-start gap-3">
                      <div className="flex-shrink-0 w-5 h-5 rounded-full bg-gradient-to-r from-cyan-500 to-teal-500 flex items-center justify-center mt-0.5">
                        <Check className="w-3 h-3 text-white" />
                      </div>
                      <p className="text-slate-700">{feature}</p>
                    </div>
                  ))}
                </div>

                {/* CTA Button */}
                <Button
                  onClick={() => document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' })}
                  className={`w-full py-6 text-base font-semibold transition-all duration-300 ${
                    plan.popular
                      ? 'bg-gradient-to-r from-cyan-500 to-teal-500 hover:from-cyan-600 hover:to-teal-600 text-white shadow-lg hover:shadow-xl'
                      : 'bg-slate-100 hover:bg-gradient-to-r hover:from-cyan-500 hover:to-teal-500 text-slate-800 hover:text-white'
                  }`}
                >
                  Book {plan.name}
                </Button>
              </div>
            </Card>
          ))}
        </div>

        {/* Additional info */}
        <div className="mt-12 text-center">
          <p className="text-slate-600 mb-2">Need a custom package?</p>
          <Button
            variant="link"
            onClick={() => document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' })}
            className="text-cyan-600 hover:text-teal-600 font-semibold"
          >
            Contact me for a personalized quote →
          </Button>
        </div>
      </div>
    </section>
  );
};

export default Pricing;
